<div class="contact-body-container">
    <div *ngIf="contact.primaryEmail || contact.secondaryEmail || contact.imHandle" class="contact_body_item">
        <div>
            <div class="h3-regular item-section">EMAIL ADDRESS</div>
            <div class="one-item" *ngIf="contact.primaryEmail">
                <div class="item-label body-3">
                    <label>Primary Email</label>
                </div>
                <div tid="contact_p_email" class="item-value body-1">
                    <a href="mailto:{{contact.primaryEmail}}"> {{contact.primaryEmail}}</a>
                </div>
            </div>
            <div class="one-item" *ngIf="contact.secondaryEmail">
                <div class="item-label body-3">
                    <label>Secondary Email</label>
                </div>
                <div tid="contact_s_email" class="item-value body-1">
                    <a href="mailto:{{contact.secondaryEmail}}"> {{contact.secondaryEmail}}</a>
                </div>
            </div>
            <div class="one-item" *ngIf="contact.imHandle">
                <div class="item-label body-3">
                    <label>IM</label>
                </div>
                <div tid="contact_IM" class="item-value body-1">
                    {{imValue}}
                </div>
            </div>
        </div>
        <div
            *ngIf="contact.businessPhone || contact.mobilePhone || contact.homePhone || contact.businessFax || contact.businessAddress || contact.homeAddress || linkedIn || twitter || facebook || skype || other || defaultRelationshipTypeName || contact.birthday || contact.aliases || contact.notes">
            <hr class="item-divider" />
        </div>
    </div>

    <div *ngIf="contact.businessPhone || contact.mobilePhone || contact.homePhone || contact.businessFax"
        class="contact_body_item">
        <div class="h3-regular item-section">PHONE NUMBER</div>
        <div class="one-item" *ngIf="contact.businessPhone">
            <div class="item-label body-3">
                <label>Work</label>
            </div>
            <div tid="contact_w_phone" class="item-value body-1">
                {{contact.businessPhone}}
            </div>
        </div>
        <div class="one-item" *ngIf="contact.mobilePhone">
            <div class="item-label body-3">
                <label>Mobile</label>
            </div>
            <div tid="contact_m_phone" class="item-value body-1">
                {{contact.mobilePhone}}
            </div>
        </div>
        <div class="one-item" *ngIf="contact.homePhone">
            <div class="item-label body-3">
                <label>Home</label>
            </div>
            <div tid="contact_h_phone" class="item-value body-1">
                {{contact.homePhone}}
            </div>
        </div>
        <div class="one-item" *ngIf="contact.businessFax">
            <div class="item-label body-3">
                <label>Fax</label>
            </div>
            <div tid="contact_fax" class="item-value body-1">
                {{contact.businessFax}}
            </div>
        </div>
        <div
            *ngIf="contact.businessAddress || contact.homeAddress || linkedIn || twitter || facebook || skype || other || defaultRelationshipTypeName || contact.birthday || contact.aliases || contact.notes">
            <hr class="item-divider" />
        </div>
    </div>

    <div *ngIf="contact.businessAddress || contact.homeAddress" class="contact_body_item">
        <div class="h3-regular item-section">ADDRESS</div>
        <div class="one-item" *ngIf="contact.businessAddress">
            <div class="item-label body-3">
                <label>Business</label>
            </div>
            <div tid="contact_b_address" class="item-value body-1">
                <div class="dont-break-out">
                    <span class="angular-with-newlines">
                        {{contact.businessAddress}}
                    </span>
                </div>
            </div>
        </div>
        <div class="one-item" *ngIf="contact.homeAddress">
            <div class="item-label body-3">
                <label>Home</label>
            </div>
            <div tid="contact_h_address" class="item-value body-1">
                <div class="dont-break-out">
                    <span class="angular-with-newlines">
                        {{contact.homeAddress}}
                    </span>
                </div>
            </div>
        </div>
        <div
            *ngIf="linkedIn || twitter || facebook || skype || other || defaultRelationshipTypeName || contact.birthday || contact.aliases || contact.notes">
            <hr class="item-divider" />
        </div>
    </div>

    <div *ngIf="linkedIn || twitter || facebook || skype || other" class="contact_body_item">
        <div class="h3-regular item-section">SOCIAL MEDIA</div>
        <div class="one-item" *ngIf="linkedIn">
            <div class="item-label body-3">
                <label>LinkedIn</label>
            </div>
            <div tid="contact_linkedIn" class="item-value body-1">
                <a target="_blank" href="{{formatExternal(linkedIn)}}"> {{linkedIn}}</a>
            </div>
        </div>
        <div class="one-item" *ngIf="twitter">
            <div class="item-label body-3">
                <label>Twitter</label>
            </div>
            <div tid="contact_twitter" class="item-value body-1">
                <a target="_blank" href="{{formatExternal(twitter)}}"> {{twitter}}</a>
            </div>
        </div>
        <div class="one-item" *ngIf="facebook">
            <div class="item-label body-3">
                <label>Facebook</label>
            </div>
            <div tid="contact_facebook" class="item-value body-1">
                <a target="_blank" href="{{formatExternal(facebook)}}"> {{facebook}}</a>
            </div>
        </div>
        <div class="one-item" *ngIf="skype">
            <div class="item-label body-3">
                <label>Skype</label>
            </div>
            <div tid="contact_skype" class="item-value body-1">
                {{skype}}
            </div>
        </div>
        <div class="one-item" *ngIf="other">
            <div class="item-label body-3">
                <label>Other</label>
            </div>
            <div [hidden]="!isOtherLink" tid="contact_other_link" class="item-value body-1">
                <a target="_blank" href="{{formatExternal(other)}}"> {{other}}</a>
            </div>
            <div [hidden]="isOtherLink" tid="contact_other" class="item-value body-1">
                {{other}}
            </div>
        </div>
        <div *ngIf="defaultRelationshipTypeName || contact.birthday || contact.aliases || contact.notes">
            <hr class="item-divider" />
        </div>
    </div>

    <div *ngIf="defaultRelationshipTypeName || contact.birthday || contact.aliases" class="contact_body_item">
        <div class="h3-regular item-section">OTHER</div>
        <div class="one-item" *ngIf="defaultRelationshipTypeName">
            <div class="item-label body-3">
                <label>Default Relationship Type</label>
            </div>
            <div tid="contact_relationshiptype" class="item-value body-1">
                {{defaultRelationshipTypeName}}
            </div>
        </div>
        <div class="one-item" *ngIf="contact.birthday">
            <div class="item-label body-3">
                <label>Birthday</label>
            </div>
            <div tid="contact_birthday" class="item-value body-1">
                {{contact.birthday}}
            </div>
        </div>
        <div class="one-item" *ngIf="contact.aliases && contact.aliases.length > 0">
            <div class="item-label body-3">
                <label>Alias</label>
            </div>
            <div tid="contact_alias" class="item-value body-1">
                {{contact.aliases.join(', ')}}
            </div>
        </div>
        <div *ngIf="contact.notes">
            <hr class="item-divider" />
        </div>
    </div>

    <div *ngIf="contact.notes" class="contact_body_item">
        <div class="h3-regular item-section">NOTES</div>
        <div *ngIf="contact.notes">
            <div tid="contact_note" class="item-note body-1 item-note-value">
                {{contact.notes}}
            </div>
        </div>
    </div>
</div>